// @ts-check
import * as React from 'react'
import PropTypes from 'prop-types'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations, tracking } from 'helpers'

// Only used on `cart_controller#index` path

const CheckoutButton = ({ cartItems, currency, disabled, disabledMessage }) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  const handleCheckout = () => {
    tracking.trackMetaEvent('InitiateCheckout', {
      content_ids: cartItems.map((item) => item.id).filter(Boolean),
      content_type: 'product_group',
      value: cartItems.reduce(
        (sum, item) => sum + (Number(item.price) || 0),
        0
      ),
      currency,
      num_items: cartItems.length
    })

    if (typeof dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'eec.checkout',
        ecommerce: {
          currencyCode: currency,
          checkout: {
            actionField: { step: 1, option: 'Cart' },
            cartItems
          }
        }
      })
    }

    window.location = localiseUrl(`${window.location.origin}/checkout`)
  }

  return (
    <div className="cart-summary__actions">
      <button
        type="button"
        disabled={disabled}
        className="btn btn--primary btn--full-width"
        onClick={() => handleCheckout()}
      >
        {t('shared.checkout')}
      </button>
      {disabledMessage && (
        <p className="cart-summary__actions__info" role="status">
          {disabledMessage}
        </p>
      )}
      <p className="cart-summary__actions__info">{t('shared.inclusive_vat')}</p>
    </div>
  )
}

CheckoutButton.propTypes = {
  currency: PropTypes.string.isRequired,
  cartItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      price: PropTypes.string,
      brand: PropTypes.string,
      category: PropTypes.string,
      variant: PropTypes.string,
      quantity: PropTypes.number
    })
  ).isRequired,
  disabled: PropTypes.bool,
  // Shown beneath the button when it's disabled, so a buyer knows this is us
  // being closed rather than something broken on their end.
  disabledMessage: PropTypes.string
}

CheckoutButton.defaultProps = {
  disabled: false,
  disabledMessage: null
}

export default withTranslations(CheckoutButton)
